export default {
    'modifyProfile.member_profile': 'Member Profile',
    'modifyProfile.error.modify_fail': 'Modification failed, please try again',
    'modifyProfile.error.different_phone_number': 'Please enter a different phone number from the previous one',
    'modifyProfile.modify': 'Modify',
    'modifyProfile.submit': 'Submit Modification',
} as Record<string, string>;
